export const GET_LEADERBOARD = 'GET_LEADERBOARD'
export const GET_LEADERBOARD_SUCCESS = 'GET_LEADERBOARD_SUCCESS'